import {useState} from "react";
import axios from "axios";
import {useNavigate} from "react-router-dom";

//defines a signup component.
const Signup=()=>{
    // useState initializes a state variable callled username.
    // with an empty string as the default value.
    const[username,setUsername]=useState("");
    const[password,setPassword]=useState("");
    const[group_name,setGroupName]=useState("");
    // useNavigate is a React router Hook that allows navigation to different pages
    const navigate=useNavigate();


    // Defines an Asynchronous function named handlesignup
    const handlesignup=async(e)=>{
        // Normally when a form is submited the browser reloads the page.
        // e.preventDefault stops this default behaviour, so the page doesn't refresh.
        e.preventDefault();
        try{
            // axios.post(url,data) is used to send data to the backend
            const response=await axios.post("https://jerinmjohn.pythonanywhere.com/api/signup/",{
                username,
                password,
                group_name
        });
        // localstorage.setItem("key",value) stores data in the browser.
        // the token received from the backend is saved with the key "token"
        localStorage.setItem("token",response.data.token);
        alert("Signup Successfull....");
        navigate("/dashboard");
        } catch(error){
            alert("Error Signing up..please try again")
        }
    };

    return(
        <div className="container mt-5">
            <div className="row justify-content-center">
                <div className="col-md-4">
                    <div className="card p-4 shadow">
                        <h2 className="text-center">Signup</h2>
                        <form onSubmit={handlesignup}>
                            <div className="mb-3">
                                <input type="text" className="form-control" placeholder="Usename"
                                onChange={(e)=>setUsername(e.target.value)} required/>
                            </div>
                            <div className="mb-3">
                                <input type="password" className="form-control" placeholder="password"
                                onChange={(e)=>setPassword(e.target.value)} required/>
                            </div>
                            <div className="mb-3">
                                <input type="text" className="form-control" placeholder="Group Name"
                                onChange={(e)=>setGroupName(e.target.value)} required/>
                            </div>
                            <div>
                                <button type="submit" className="btn btn-success w-100">Signup</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}
    export default Signup;
